import { DownOutlined } from "@ant-design/icons";
import { Button, Dropdown, Row, Skeleton, Space } from "antd";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import PostApiCall from "../API/POSTAPI";
import ProductCard from "../ProductCard/ProductCard";
import "./ProductListing.css";
import nodata from "../img/not-avaiabl.png";
import { store } from "../Helper/Store";
import GetSeoData from "../API/GetSeoData";
import { Col, Container } from "react-bootstrap";
import banner from "../img/inner-desktop-banners/blessings-inner-our-services-banner.webp";
import bannerMobile from "../img/inner-mobile-banners/blessing-our-services-mobile.webp";
// Static banner imports (or use public paths)
import booksDesktop from "../img/inner-desktop-banners/blessing-inner-book-banner.webp";
import booksMobile from "../img/inner-mobile-banners/BOOK-blessing-mobile.webp";

import braceletsDesktop from "../img/inner-desktop-banners/blessing-inner-page-bracelet-banner.webp";
import braceletsMobile from "../img/inner-mobile-banners/BRACELET-blessing-mobile.webp";

import pendantsRingsDesktop from "../img/inner-desktop-banners/blessing-inner-rings-banner.webp";
import pendantsRingsMobile from "../img/inner-mobile-banners/JEWEL-blessing-mobile.webp";

// Optional: default banner
import defaultDesktop from "../img/inner-desktop-banners/blessing-inner-book-banner.webp";
import defaultMobile from "../img/inner-mobile-banners/BOOK-blessing-mobile.webp";
const categoryBanners = {
  books: {
    desktop: booksDesktop,
    mobile: booksMobile,
    heading: " Books that guide, heal,",
    subHeading: " and inspire",
  },
  bracelets: {
    desktop: braceletsDesktop,
    mobile: braceletsMobile,
    heading: "Zodiac Sign Bracelet",
    subHeading: "for Luck",
  },
  pendantsrings: {
    desktop: pendantsRingsDesktop,
    mobile: pendantsRingsMobile,
    heading: "Pendant ",
    subHeading: "& Ring",
  },
};

const normalizeCategory = (name) =>
  name?.toLowerCase().replace(/[^a-z0-9]/gi, "");
export default function ProductListing() {
  const params = useParams();
  const [apiData, setApiData] = useState([]);
  const [productClass, setProductClass] = useState("col-6 col-lg-3 mb-4");
  const [dataLoading, setDataLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 568);
  const { cartItems } = useContext(store);
  useEffect(() => {
    getItems();
  }, [params.categoryname]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [params.categoryname]);
  const getItems = () => {
    PostApiCall.postRequest(
      {
        verticalroute: params.categoryname,
        stateid: null,
      },
      "Get_All_Items"
    ).then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          const sortbyLatest = obj1.data.sort(
            (a, b) => b.fld_variantid - a.fld_variantid
          );
          setApiData(sortbyLatest);
          setDataLoading(false);
        }
      })
    );
  };
  const items = [
    {
      label: "Price, High to Low",
      key: 1,
      value: "Price, High to Low",
    },
    {
      label: "Price, Low to High",
      key: 2,
      value: "Price, Low to High",
    },
  ];
  const handleMenuClick = (value) => {
    const sortedproducts = [...apiData];
    if (value.key == 1) {
      sortedproducts.sort((a, b) => {
        return b.fld_selling_price - a.fld_selling_price;
      });
    } else if (value.key == 2) {
      sortedproducts.sort((a, b) => {
        return parseInt(a.fld_selling_price) - parseInt(b.fld_selling_price);
      });
    }
    setApiData(sortedproducts);
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };
  const categoryKey = normalizeCategory(apiData[0]?.fld_categoryname);
  const banner = categoryBanners[categoryKey] || {
    desktop: defaultDesktop,
    mobile: defaultMobile,
  };
  return (
    <>
      <section className="inner-section about-page">
        {/* <div className="page-title-area product-listing">
        <div className="container-fluid pe-4 h-100 d-flex justify-content-end align-items-center">
          <div className="page-title-content">
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>Our Products</li>
            </ul>
          </div>
        </div>
      </div> */}
        <div className="position-relative about-banner">
          <img
            src={isMobile ? banner.mobile : banner.desktop}
            alt={`${apiData[0]?.fld_categoryname} banner`}
            className="img-fluid w-100"
          />
          <h1>{banner?.heading} <br className="d-lg-none d-block" />{banner?.subHeading}</h1>
        </div>
        {/* <GetSeoData type='Vertical' id={params.categoryid} route={params.subcategoryname ? params.subcategoryname : params.productcategoryname ? params.productcategoryname : params.categoryname} /> */}
        <GetSeoData
          type={params.productcategoryname ? "Category" : "Vertical"}
          id={params.categoryid}
          route={
            params.subcategoryname
              ? params.subcategoryname
              : params.productcategoryname
                ? params.productcategoryname
                : params.categoryname
          }
        />
        <section className="spacing mt-4 mt-lg-5">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <h1 className="main-heading text-center mb-lg-0">
                  {apiData[0]?.fld_categoryname}
                </h1>
                <div className="d-flex justify-content-end align-items-center mb-4">
                  {apiData.length !== 0 && (
                    <Dropdown menu={menuProps}>
                      <Button>
                        <Space>
                          Sort by
                          <DownOutlined />
                        </Space>
                      </Button>
                    </Dropdown>
                  )}
                </div>
              </div>

              {apiData.length > 0 ? (
                apiData
                  .filter((dat) => dat.fld_status == "Active")
                  .map((val) => {
                    const isInCart = cartItems.find(
                      (item) => item.fld_variantid === val.fld_variantid
                    );
                    return (
                      <div key={val.fld_variantid} className={`${productClass}`}>
                        <ProductCard itemdata={val} isInCart={isInCart} />
                      </div>
                    );
                  })
              ) : dataLoading === false ? (
                <div className="d-flex justify-content-center align-items-center w-100 listingpage-height py-5 mb-5 nodata flex-column">
                  <img
                    className="mb-3 img-fluid"
                    alt="not available"
                    src={nodata}
                  />
                  <p className="fs-5">
                    The items you are searching for are not available.
                  </p>
                </div>
              ) : null}
              {window.location.pathname === "/ct/bracelets" &&
                apiData.length > 0 && (
                  <div className="">
                    <Container fluid className="px-0">
                      <Row>
                        <Col xs={12} className="px-0">
                          <h3>
                            Go over Strong Astrology and Evil Eye Bracelets for
                            All Purposes.
                          </h3>
                          <p>
                            Our carefully chosen selection of astrological and
                            evil eye bracelets at Blessings Astrology are more
                            than simply accessories; they are potent spiritual
                            instruments that can improve your life. Our wristbands
                            are designed to transmit mystical energy and heavenly
                            meaning, whether you're looking for protection,
                            healing, positivity, or alignment with your zodiac
                            sign. Among our collection's most sought-after items
                            are our Evil Eye Bracelets. Throughout history, the
                            evil eye has served as a protective sign, protecting
                            its wearer from evil energy, envy, and invisible
                            threats. Every Evil Eye Protection Bracelet in our
                            collection is crafted with holy purpose, utilizing
                            genuine materials to channel protection and ward off
                            negative energies. Our collection of delicate yet
                            potent evil eye bracelets for women and attractive and
                            long-lasting evil eye bracelets for men flawlessly
                            combines ancient symbolism with contemporary design
                            for people seeking elegance with a deeper spiritual
                            meaning.
                          </p>
                          <p>
                            Our Astrology Bracelets are perfect for strengthening
                            your spiritual bond if you're drawn to the planetary
                            and celestial energies. These bracelets, which were
                            created based on birth charts and astrological
                            concepts, are ideal for balancing your energy with the
                            universe. For a combination of strength and
                            understated appeal, pick from a large selection of
                            Astrology Bracelets for Women that exude elegance and
                            heavenly energy, or bold and empowering Astrology
                            Bracelets for Men. With our Zodiac Sign Bracelets,
                            which are designed to resonate with the distinct
                            vibrations of each zodiac sign, you may delve deeper
                            into your cosmic identity. Our selection of Zodiac
                            Sign Bracelets Online includes the ideal item to
                            showcase your inner potential and personality, ranging
                            from Aries to Pisces. These are customized talismans
                            that promote emotional equilibrium, self-assurance,
                            and clarity; they are not only ornamental items.
                          </p>
                          <p>
                            For those who enjoy crystals and gemstones, our Zodiac
                            Stone Bracelets blend the therapeutic qualities of
                            natural stones with the astrological abilities. Each
                            stone is selected according to your astrological birth
                            chart to enhance power, love, focus, and success,
                            whether amethyst is for Pisces or garnet is for
                            Capricorn. Regularly wearing your zodiac bracelets
                            protects you and helps you match your energy with your
                            life's mission. Our Black Magic Protection Bracelets
                            are beneficial for anyone who are dealing with extreme
                            negativity or who are feeling spiritually exhausted.
                            These wristbands are spiritually charged to protect
                            against negative spiritual forces, psychic attacks,
                            and black magic. These bracelets provide a shield of
                            divine protection around your aura and are
                            particularly effective when used in conjunction with
                            astrological cures.
                          </p>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                )}
              {dataLoading === true && (
                <div className="col-12">
                  <div className="row blank-section product-listing-skeleton mb-4">
                    <div className="col-6 col-md-12 col-lg-3">
                      <div className="product-box d-flex flex-column">
                        <Skeleton.Image className="w-100" />
                        <Skeleton.Button className="w-75 mt-2" />
                        <Skeleton.Button className="w-100 mt-2" />
                      </div>
                    </div>
                    <div className="col-6 col-md-12 col-lg-3">
                      <div className="product-box d-flex flex-column">
                        <Skeleton.Image className="w-100" />
                        <Skeleton.Button className="w-75 mt-2" />
                        <Skeleton.Button className="w-100 mt-2" />
                      </div>
                    </div>
                    <div className="col-6 col-md-12 col-lg-3">
                      <div className="product-box d-flex flex-column">
                        <Skeleton.Image className="w-100" />
                        <Skeleton.Button className="w-75 mt-2" />
                        <Skeleton.Button className="w-100 mt-2" />
                      </div>
                    </div>
                    <div className="col-6 col-md-12 col-lg-3">
                      <div className="product-box d-flex flex-column">
                        <Skeleton.Image className="w-100" />
                        <Skeleton.Button className="w-75 mt-2" />
                        <Skeleton.Button className="w-100 mt-2" />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
